import { Chip, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationNamespace } from 'i18n';
import { FundsRequest } from 'types';
import { fundsRequestUtils } from 'utils';

type Props = {
  fundsRequest: Pick<FundsRequest, 'internalWalletDepositTransaction'>;
};

export const TronSourceLabel: React.FC<Props> = ({ fundsRequest }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.funds_request',
  });

  if (!fundsRequestUtils.isTronSourced(fundsRequest)) {
    return null;
  }

  return (
    <Tooltip title={t('tron_tooltip')}>
      <Chip
        label="TRON"
        color="warning"
        variant="outlined"
        size="small"
        sx={{ height: 20 }}
      />
    </Tooltip>
  );
};
